import { injectIntl } from 'react-intl';
import * as types from './types';
import { actionForState } from '../../../utils/helpers';

const INITIAL_STATE = {

  fetchDirectoryAction: {
    success: false,
    loading: false,
    error: false
  },
  fetchDirectoryDetailAction: {
    success: false,
    loading: false,
    error: false
  }
};

// eslint-disable-next-line func-names
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    /* ******************************** */
    /*         LOAD ASSET TYPES         */
    /* ******************************** */
    case types.GET_DIRECTORY.pending:
      return {
        ...state,
        fetchDirectoryAction: actionForState(state.action, 'pending')
      };
    case types.GET_DIRECTORY.success:
      return {
        ...state,
        schemas: action.payload,
        fetchDirectoryAction: actionForState(state.action, 'success')
      };
    case types.GET_DIRECTORY.error:
      return {
        ...state,
        fetchDirectoryAction: actionForState(state.action, 'error')
      };


    case types.GET_DIRECTORY_DETAIL.pending:
      return {
        ...state,
        fetchDirectoryDetailAction: actionForState(state.action, 'pending')
      };
    case types.GET_DIRECTORY_DETAIL.success:
      return {
        ...state,
        schemas: action.payload,
        fetchDirectoryDetailAction: actionForState(state.action, 'success')
      };
    case types.GET_DIRECTORY_DETAIL.error:
      return {
        ...state,
        fetchDirectoryDetailAction: actionForState(state.action, 'error')
      };

    default:
      return injectIntl(state);
  }
}
